import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { enqueueNotification, hideModal } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// app
import { multipartAdminAxios } from '../../admin.api';
import { CLIENT_OFFICE_LIST, OPERATIONAL_CLIENTS } from '../../queryKeys';

export const useEditOperationalClient = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const handleSettled = (data) => {
    dispatch(hideModal());
  };
  const handleError = (err) => {
    const errorParams = {
      file: 'admin.mutations.useEditOperationalClient',
      message: 'Data missing for PUT request',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
    dispatch(enqueueNotification('notification.admin.parentClientPatchFail', 'error'));
    dispatch(hideModal());
  };

  const handleSuccess = (res) => {
    const { data } = res;
    queryClient.invalidateQueries(OPERATIONAL_CLIENTS);
    queryClient.invalidateQueries(CLIENT_OFFICE_LIST);

    dispatch(
      enqueueNotification('notification.admin.parentClientPatchSuccess', 'success', {
        data: { clientName: data?.name },
      })
    );
    dispatch(hideModal());
  };

  return useMutation(
    async (requestData) => {
      const { newParentClient, id } = requestData;

      if (!utils.generic.isValidObject(newParentClient)) {
        throw new Error('Invalid operational client request body');
      }

      const form = new FormData();
      form.append('id', id);
      form.append('name', newParentClient.name);
      form.append('odsParentClientName', newParentClient.odsParentClientName === null ? '' : newParentClient.odsParentClientName);

      if (!isEmpty(newParentClient?.logo)) {
        newParentClient.logo.forEach((file) => form.append('logo', file));
      }

      return await multipartAdminAxios.put('client/operational', form);
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      onSettled: handleSettled,
    }
  );
};
